import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  Space,
  Form,
  Input,
  Row,
  Col,
  Spin,
  Radio,
  Select,
  DatePicker,
  Card,
  Typography
} from "antd";
import {
  SyncOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";
import Container from "../../Layout/Container";
import { Link, useHistory, useLocation } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { getPdfNewProcess, getUsersNameAsyn, clearAllUsersNameState, getReferenceNoAsyn, AddMultyProcessDocument, clearAddResponseState, adddmultipleprocesdocumentSelector, clearState, clearResponseState } from './ChdAddMultipleProcessDocumentSlice';
import moment from 'moment';
import { authSelector } from '../../Auth/authSlice';
import { myRef } from '../../newRef'

const { Title, Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;
const antIcon = <SyncOutlined style={{ fontSize: 32, color: '#ff4500' }} spin />;

export default function AddMultipleProcessDocument() {
  const location = useLocation();
  const [isToast, setToast] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  let history = useHistory();
  const [subjectVal, setSubjectVal] = useState('')
  const [form] = Form.useForm();
  const [UserList, setUserList] = useState([]);
  const [setslecetedUserList] = useState([]);
  const [sendUserData, setsendUserData] = useState([]);
  const [showForm, setshowForm] = useState(false);

  const { isSuccess, isError, errorMessage, seenStampData, allUserNames, isUsersNameSuccess, isdataAdded, processData, isprocessData, isResponse, referenceNos } = useSelector(
    adddmultipleprocesdocumentSelector
  );

  const { user } = useSelector(authSelector);
  const loggedInUser = user.username;

  // UI Styles Object
  const styles = {
    pageWrapper: { padding: '24px', background: '#f0f2f5', minHeight: '100vh' },
    card: { borderRadius: '12px', boxShadow: '0 8px 24px rgba(0,0,0,0.05)', border: 'none' },
    header: { padding: '24px 40px', borderBottom: '1px solid #f0f0f0', background: '#fff', borderRadius: '12px 12px 0 0' },
    formSection: { padding: '40px' },
    label: { fontWeight: '600', color: '#6B778C', fontSize: '14px', marginBottom: '8px', display: 'block' },
    input: { borderRadius: '6px', height: '44px' },
    textArea: { borderRadius: '6px' },
    footer: { padding: '24px 40px', borderTop: '1px solid #f0f0f0', textAlign: 'right', background: '#fafafa', borderRadius: '0 0 12px 12px' },
    loadingContainer: { textAlign: 'center', padding: '100px 0', background: '#fff', borderRadius: '12px' }
  };

  useEffect(() => {
    dispatch(clearState());
    setLoading(true);
    dispatch(getPdfNewProcess(location.state.documentId));
    dispatch(getReferenceNoAsyn());
    dispatch(getUsersNameAsyn());
  }, []);

  useEffect(() => {
    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage.toUpperCase());
    }
    if (isSuccess) setLoading(false);

    if (isResponse) {
      setLoading(false);
      dispatch(clearResponseState());
    }

    if (isdataAdded) {
      setLoading(false);
      dispatch(clearAddResponseState());
      setToast(true);
      toast.success(errorMessage.toUpperCase());
      history.push({ pathname: '/dashboard' });
    }

    if (isprocessData) {
      setTimeout(async () => {
        await form.setFieldsValue({
          securityClassification: processData.securityClassification,
          documentType: processData.documentType,
          referenceNumber: processData.referenceNumber,
          restrictDownload: processData.restrictDownload === true ? 'Yes' : 'No',
          receivedFrom: processData.receivedFrom && processData.receivedFrom != null ? processData.receivedFrom : null,
          controlNumber: processData.controlNumber && processData.controlNumber != null ? processData.controlNumber : null,
          subject: processData.subject,
          signalDate: processData.signalDate && processData.signalDate != null ? moment(processData.signalDate) : null,
          externalReferenceNumber: processData.externalReferenceNumber,
          seenStamp: processData.seenStamp === true ? 'Yes' : 'No',
        });
        setLoading(false);
        setshowForm(true);
      }, 1000);
    }

    if (isUsersNameSuccess) {
      setUserList(allUserNames);
      dispatch(clearAllUsersNameState());
    }
  }, [isError, isSuccess, isResponse, allUserNames, isUsersNameSuccess, isdataAdded, processData, isprocessData]);

  const onClickListChange = (x, e) => {
    let dummyArray = [];
    for (var i = 0; i < e.length; i++) {
      let data = {
        "username": e[i].props.username,
        "department": 'Chief of Air Staff',
        "departmentType": e[i].props.branch == true ? 'Branch' : e[i].props.independentOffice == true ? 'Independent Office' : e[i].props.independentDirectorate == true ? 'Independent Directorate' : null,
        "departmentTypeName": e[i].props.branch == true ? e[i].props.b_name : e[i].props.independentOffice == true ? e[i].props.io_name : e[i].props.independentDirectorate == true ? e[i].props.id_name : null,
        "directorateWithinBranch": e[i].props.bd_name ? e[i].props.bd_name : '',
        "firstName": e[i].props.fullName,
      };
      dummyArray.push(data);
    }
    setsendUserData(dummyArray);
  };

  const newReferenceNos = () => {
    let refChild = [];
    myRef.forEach(el => {
      let mx = el.substring(0, 7);
      refChild.push(<Option key={el} value={mx} props={el}>{el}</Option>);
    });
    return refChild;
  };

  const shadowuserFunc = (theUser, usertocopy) => {
    return {
      "username": usertocopy,
      "department": 'Chief of Air Staff',
      "departmentType": theUser.departmentType,
      "departmentTypeName": theUser.departmentTypeName,
      "directorateWithinBranch": theUser.directorateWithinBranch,
      "firstName": usertocopy.toUpperCase(),
    };
  };

  const onFinish = (values) => {
    let tempArray = [...sendUserData];
    let someusers = sendUserData.map(u => u.username);

    for (var i = 0; i < sendUserData.length; i++) {
      let guser = sendUserData[i].username;
      if (((guser.indexOf('c') === 0) && (guser.indexOf('c') != -1) && !(guser.includes('cc'))) || (guser == "ccis")) {
        if (!someusers.includes("aa" + guser)) {
          tempArray.push(shadowuserFunc(sendUserData[i], "aa" + guser));
        }
      }
      if (guser == 'airsec') {
        if (!someusers.includes("aa" + guser)) {
          tempArray.push(shadowuserFunc(sendUserData[i], "aa" + guser));
        }
      }
      if (i < 1) {
        if (((loggedInUser.indexOf('c') === 0) && (loggedInUser.indexOf('c') != -1) && !(loggedInUser.includes('cc')) || (loggedInUser == "ccis")) && (!someusers.includes(`cc${loggedInUser}`))) {
          tempArray.push(shadowuserFunc(sendUserData[i], `cc${loggedInUser}`));
        }
        if ((loggedInUser == 'airsec') && (!someusers.includes(`cc${loggedInUser}`))) {
          tempArray.push(shadowuserFunc(sendUserData[i], `cc${loggedInUser}`));
        }
        if ((loggedInUser == 'airsec') && (!someusers.includes(`aa${loggedInUser}`))) {
          tempArray.push(shadowuserFunc(sendUserData[i], `aa${loggedInUser}`));
        }
        if (((loggedInUser.indexOf('c') === 0) && (loggedInUser.indexOf('c') != -1) && !(loggedInUser.includes('cc')) || (loggedInUser == "ccis")) && (!someusers.includes(`aa${loggedInUser}`))) {
          tempArray.push(shadowuserFunc(sendUserData[i], `aa${loggedInUser}`));
        }
        if (!(loggedInUser.includes('dd')) && (loggedInUser.indexOf('d') != -1) && (loggedInUser.indexOf('d' == 0)) && (!someusers.includes(`pa${loggedInUser}`))) {
          tempArray.push(shadowuserFunc(sendUserData[i], `cc${loggedInUser}`));
        }
      }
    }

    let document = {
      "processId": processData.processId,
      "securityClassification": values.securityClassification,
      "documentType": values.documentType,
      "referenceNumber": values.referenceNumber,
      "remarks": values.remarks,
      "casstickernote": values.casstickernote,
      "restrictDownload": values.restrictDownload == 'Yes' ? true : false,
      "receivedFrom": values.receivedFrom ? values.receivedFrom : null,
      "controlNumber": values.controlNumber ? values.controlNumber : null,
      "template_uuid": values.template_uuid,
      "subject": values.subject,
      "signalDate": values.signalDate ? moment(values.signalDate).format() : null,
      "externalReferenceNumber": values.externalReferenceNumber ? values.externalReferenceNumber : null,
      "pdfFile": processData.pdfFile,
      "automaticTemplate": true,
      "users": sendUserData,
      "cos_seenStamp": values.seenStamp == "Yes" ? (seenStampData && seenStampData[0].uuid) : null
    };

    setLoading(true);
    dispatch(AddMultyProcessDocument(document));
  };

  const onDateIncomingChange = (value, dateString) => { }

  const getAppt = () => {
    return UserList.map(u => (
      <Option key={u.username} value={u.username} props={u}>{u.username.toUpperCase()}</Option>
    ));
  }

  return (
    <div style={styles.pageWrapper}>
      <Container>
        <Spin indicator={antIcon} style={{ position: 'fixed', zIndex: 1111, left: '50%', top: '50%' }} spinning={isLoading} />
        
        <Breadcrumb style={{ marginBottom: 24, fontSize: '14px' }} separator=">">
          <Breadcrumb.Item><Link to="/dashboard">Dashboard</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Add Multiple Process Document</Breadcrumb.Item>
        </Breadcrumb>

        <Card style={styles.card} bodyStyle={{ padding: 0 }}>
          <div style={styles.header}>
            <Title level={3} style={{ margin: 0 }}><FileTextOutlined style={{ marginRight: 12, color: '#ff4500' }} /> Add Document</Title>
            <Text type="secondary">Initiate multiple processes for the uploaded document.</Text>
          </div>

          {isToast && (
            <Toaster position="top-right">
              {(t) => (
                <ToastBar toast={t}>
                  {({ icon, message }) => (
                    <Space>{icon}{message}{t.type !== 'loading' && <Button type="text" size="small" onClick={() => toast.dismiss(t.id)}>X</Button>}</Space>
                  )}
                </ToastBar>
              )}
            </Toaster>
          )}

          <Form form={form} layout="vertical" onFinish={onFinish}>
            {showForm ? (
              <div style={styles.formSection}>
                <Row gutter={32}>
                  <Col span={12}>
                    <Form.Item name="securityClassification" label={<span style={styles.label}>Security Classification</span>} rules={[{ required: true }]}>
                      <Select style={styles.input}>
                        <Option value="Restricted">Restricted</Option>
                        <Option value="Confidential">Confidential</Option>
                        <Option value="Secret">Secret</Option>
                        <Option value="Top-Secret">Top-Secret</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="referenceNumber" label={<span style={styles.label}>Reference Number</span>} rules={[{ required: true }]}>
                      <Select style={styles.input}>{newReferenceNos()}</Select>
                    </Form.Item>
                  </Col>
                </Row>

                {/* <Row gutter={32}>
                  <Col span={12}>
                    <Form.Item name="restrictDownload" label={<span style={styles.label}>Restrict Download?</span>} initialValue={'Yes'}>
                      <Radio.Group buttonStyle="solid">
                        <Radio.Button value="Yes">Yes</Radio.Button>
                        <Radio.Button value="No">No</Radio.Button>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="seenStamp" label={<span style={styles.label}>Include Seen Stamp?</span>} initialValue={'Yes'}>
                      <Radio.Group buttonStyle="solid">
                        <Radio.Button value="Yes">Yes</Radio.Button>
                        <Radio.Button value="No">No</Radio.Button>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row> */}

                <Form.Item name="users_uuid" label={<span style={styles.label}>Select Recipients (APPTS)</span>}>
                  <Select mode="multiple" allowClear rules={[{ required: true }]} placeholder="Search by appointment..." onChange={onClickListChange} style={{ width: '100%' }}>
                    {getAppt()}
                  </Select>
                </Form.Item>

                <Form.Item name="subject" label={<span style={styles.label}>Subject</span>} rules={[{ required: true }]}>
                  <TextArea rows={2} style={styles.textArea} placeholder="Enter subject" />
                </Form.Item>

                <Form.Item name="remarks" label={<span style={styles.label}>Remarks</span>} rules={[{ required: true }]}>
                  <TextArea rows={2} style={styles.textArea} placeholder="Enter remarks" />
                </Form.Item>

                {/* <Form.Item name="casstickernote" label={<span style={styles.label}>Sticker Note to CAS</span>}>
                  <TextArea rows={2} style={styles.textArea} placeholder="Enter sticker note" />
                </Form.Item> */}
              </div>
            ) : (
              <div style={styles.loadingContainer}>
                <Spin indicator={antIcon} />
                <Title level={4} style={{ marginTop: 24, fontWeight: 400 }}>Populating document's data...</Title>
              </div>
            )}

            <div style={styles.footer}>
              <Space size="middle">
                <Link to="/dashboard">
                  <Button size="large" style={{ borderRadius: '8px' }}>Cancel</Button>
                </Link>
                {showForm && (
                  <Button type="primary" htmlType="submit" size="large" style={{ borderRadius: '8px', background: '#ff4500', borderColor: '#ff4500', padding: '0 40px' }}>
                    Submit Process
                  </Button>
                )}
              </Space>
            </div>
          </Form>
        </Card>
      </Container>
    </div>
  );
}